import { useTranslation } from 'react-i18next';
import type { QrCode } from '../api/types';
import { codeTypeIcon, codeTypeLabel, codeTypeOf } from '../codeType';

export function TypeTag({ qrCode }: { qrCode: Pick<QrCode, 'kind' | 'contact'> }) {
  const { t } = useTranslation();
  const type = codeTypeOf(qrCode);

  return (
    <span className="type-tag">
      <i className={`pi ${codeTypeIcon(type)}`} aria-hidden="true" />
      {codeTypeLabel(type, t)}
    </span>
  );
}
